import { Treemap } from '@arra/core';
import { ResponsiveTreeMap } from '@nivo/treemap';
import {
  SeedsTooltipComponent,
  SeedsTooltipRow,
} from './SeedsTooltipComponent';

const CustomTooltip = (props: any) => {
  const data = props.node.data;
  return (
    <SeedsTooltipComponent>
      <SeedsTooltipRow
        color={data.color}
        category={data.name}
        value={data.loc}
        unit={data.unit}
      />
    </SeedsTooltipComponent>
  );
};

const TreemapComponent = ({ result }: { result: Treemap }) => {
  const myColor = (node: any) => {
    return node.data.color;
  };
  if (!result?.data) {
    return null;
  }
  return (
    <ResponsiveTreeMap
      data={result?.data}
      identity="name"
      value="loc"
      valueFormat=".02s"
      margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
      enableLabel={true}
      label={(node) => node.data.name}
      labelSkipSize={16}
      labelTextColor={{ from: 'color', modifiers: [['darker', 3]] }}
      enableParentLabel={true} 
      parentLabel= {(node) => node.data.name}
      parentLabelSize={22}
      parentLabelPosition="left"
      parentLabelPadding={6}
      parentLabelTextColor={{ from: 'color', modifiers: [['darker', 5]] }}
      leavesOnly={false}
      innerPadding={5}
      borderWidth={0}
      tooltip={CustomTooltip}
      colors={myColor}
      nodeOpacity={1}
      theme={{
        labels: {
          text: {
            fontSize: 16,
            fontWeight: 600,
          },
        },
      }}
      // layers={['nodes', CustomParentLabel]}
    />
  );
};

const CustomParentLabel = ({ nodes }: { nodes: any[] }) => {
  return (
    <>
      {nodes
        .filter((node) => node.treeDepth === 1)
        .map((node) => (
          <text
            key={node.id}
            x={node.x + 6}
            y={node.y + 20}
            fill="#000"
            fontSize="18" 
            fontWeight="700"
            alignmentBaseline="middle"
          >
            {node.data.name}
          </text>
        ))}
    </>
  );
};


export default TreemapComponent;
